{
  "markread": "全部标记为已读",
  "newest": "最新条目",
  "unread": "未读条目",
  "starred": "加星标的条目",
  "tags": "标签",
  "alltags": "所有标签",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 小时},other {# 小时}}前",
  "minutes": "{0,plural,one {1 分钟},other {# 分钟}}前",
  "seconds": "{0,plural,one {1 秒},other {# 秒}}前",
  "days": "{0,plural,zero {今天},one {昨天},other {# 天前}}",
  "star": "加星标",
  "unstar": "取消星标",
  "mark": "标记为已读",
  "unmark": "标记为未读",
  "load_img": "加载图片",
  "open_window": "打开",
  "searchbutton": "搜索",
  "sources": "源",
  "source_add": "添加源",
  "source_opml": "或导入 OPML 文件/Google 阅读器订阅",
  "source_export": "导出源",
  "source_edit": "编辑",
  "source_delete": "删除",
  "source_warn": "确认要删除该源?",
  "source_new": "新的源",
  "source_title": "标题",
  "source_tags": "标签",
  "source_comma": "以逗号分隔",
  "source_select": "请选择源",
  "source_type": "类型",
  "source_save": "保存",
  "source_cancel": "取消",
  "source_saved": "已保存",
  "source_last_post": "更新于",
  "no_entries": "没有条目",
  "more": "更多",
  "login": "登录",
  "login_username": "用户名",
  "login_password": "密码",
  "no_title": "无标题",
  "logoutbutton": "登出",
  "loginbutton": "登录",
  "error_logout": "不能登出：",
  "settingsbutton": "设置",
  "app_reload": "再启动",
  "error_session_expired": "会话已过期",
  "close_entry": "关闭",
  "error_sync": "无法从服务器同步新的更改：",
  "share_pocket_label": "保存到 Pocket",
  "searchremove": "隐藏搜索",
  "error_share_native_abort": "无法分享条目 - 可能是缺少分享对象或您已取消分享。",
  "error_mark_items": "无法标记所有可见项目：",
  "share_twitter_label": "分享到 Twitter",
  "share_wallabag_label": "保存到 Wallabag",
  "filter": "筛选",
  "online_count": "服务器可用的条目",
  "offline_navigation_unavailable": "离线模式下暂时不能切换标签和来源。",
  "source_menu": "更多操作",
  "source_browse": "浏览",
  "offline_count": "本地可用的条目",
  "next": "下一个",
  "share_native_label": "分享",
  "refreshbutton": "更新数据源",
  "share_diaspora_label": "分享到 Diaspora",
  "share_wordpress_label": "分享到 WordPress",
  "search_label": "搜索词",
  "share_mail_label": "通过邮件分享",
  "source_warn_cancel_dirty": "丢弃未保存的更改？",
  "share_copy_label": "复制链接到剪切板",
  "source_filter": "筛选",
  "share_facebook_label": "分享到 Facebook",
  "tag_change_color_button_title": "更改颜色",
  "experimental": "试验性的",
  "login_invalid_credentials": "错误的用户名或密码",
  "error_check_log_file": "发生了一个错误，请检查日志文件 “{0}”。",
  "login_offline": "离线存储",
  "error_unknown_source": "未知来源 ID：",
  "error_mark_item": "无法标记或取消标记：",
  "error_star_item": "无法星标或取消星标：",
  "error_loading": "加载错误：",
  "article_reading_time": "{0} 分钟阅读时长",
  "sources_loading": "数据源加载中…",
  "no_sources": "数据源未配置。",
  "source_deleting": "正在删除数据源…",
  "source_autotitle_hint": "留空以自动填充标题",
  "source_pwd_placeholder": "没有改变",
  "source_params_loading": "正在加载参数…",
  "source_saving": "正在保存数据源更改…",
  "source_refresh": "刷新此数据源",
  "source_go_to_settings": "在设置中打开",
  "sources_leaving_unsaved_prompt": "保留未保存的数据源更改？",
  "entries_loading": "加载条目中…",
  "login_in_progress": "尝试登录中…",
  "error": "发生了一个错误",
  "error_check_system_logs": "发生了一个错误，请检查你的系统日志。",
  "error_unwritable_logs": "无法写入日志。",
  "streamerror": "没有加载到条目，重新加载？",
  "sources_refreshed": "数据源已刷新",
  "app_update": "selfoss 已被更新，请重新加载",
  "error_add_source": "无法添加源：",
  "error_edit_source": "无法保存源更改：",
  "error_delete_source": "无法删除源：",
  "error_load_tags": "无法加载标签：",
  "error_unknown_tag": "未知的标签：",
  "error_loading_stats": "无法加载统计信息：",
  "error_saving_color": "无法保存新颜色：",
  "error_refreshing_source": "无法刷新数据源：",
  "error_offline_storage": "离线存储出错：{0} ，请尝试重新加载。离线模式已被临时禁用。",
  "error_offline_storage_not_available": "离线存储不可用。确保您的网络浏览器 {0} 支持 IndexedDB API{1}，如果您使用的是基于 Google Chrome 的浏览器，请确保您没有在隐身模式下运行 selfoss。",
  "error_invalid_subsection": "无效的小节：",
  "error_configuration": "无法加载配置。",
  "info_url_copied": "URL 已复制到剪贴板。",
  "error_share_native": "无法分享条目。",
  "article_actions": "动作",
  "reload_list": "重新加载列表",
  "login_error_generic": "无法登录: {errorMessage}",
  "error_unauthorized": "请 {link_begin}登录{link_end} 以继续。",
  "share_mastodon_label": "在 Mastodon 上分享"
}
